import { render } from "./SurveyForm.vue?vue&type=template&id=76e767c7&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"

import "./SurveyForm.vue?vue&type=style&index=0&id=76e767c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e767c7"]])

export default __exports__